$(document).ready(function () {

    $(window).resize(function(){
        blinkedLamps();
    });

    blinkedLamps();
    function blinkedLamps() {
        var headerLogo = $('header .logo');
        $('header .logo ul').html('');
        for (var j = 1; j <= 15; j++) {
            $('header .logo ul').append('<li></li>');
        }
        var winWidth = $(window).width();
        var headerLogoWidth = headerLogo.width();
        var startBeforeLogo = 0;
        var spaceBeforeLogo = headerLogo.offset().left - headerLogo.parent().offset().left;
        var endBeforeLogo = spaceBeforeLogo;
        var startAfterLogo = spaceBeforeLogo + headerLogoWidth;
        var spaceAfterLogo = winWidth - (spaceBeforeLogo + headerLogoWidth);
        var endAfterLogo = winWidth;
        var lightWidth = headerLogo.find('li:eq(0)').width();

        $('.lights-outer').html('');
        insertLights(startBeforeLogo, endBeforeLogo, spaceBeforeLogo, lightWidth, 'before');
        insertLights(startAfterLogo, endAfterLogo, spaceAfterLogo, lightWidth, 'after');

        $('header .logo li, .lights-outer li').each(function (index) {
            if (index % 2 == 0) {
                $(this).addClass('active');
            }
        });
        var lastBefore = $('header li.before').last();
        var firstAfter = $('header li.after').first();
        var firstAndLastInLogo = $('header .logo li').first();
        if (lastBefore.css('background-position-x') == firstAndLastInLogo.css('background-position-x')) {
            $("header li.before").toggleClass("active");
        }
        if (firstAfter.css("background-position-x") == firstAndLastInLogo.css("background-position-x")) {
            $("header li.after").toggleClass("active");
        }
        lightBeforeLi();
        function lightBeforeLi() {
            lighten($("li.before"), lightLogoLi);
        }
        function lightLogoLi() {
            lighten($("header .logo li"), lightAfterLi);
        }
        function lightAfterLi() {
            lighten($("li.after"), lightBeforeLi);
        }
        function lighten(target, callback) {
            $(target).each(function (i) {
                var delayer = 100;

                $(this).delay(i * delayer).queue(function () {
                    $(this).addClass("lighten").dequeue();
                });

                $(this).delay(delayer).queue(function () {
                    $(this).removeClass("lighten").dequeue();
                    if (i == $(target).length - 1) {
                        callback();
                    }
                })
            });

            if ($(target).length == 0) {
                callback()
            }
        }
    }
    function insertLights(from, end, remainingSpace, width, newClass) {
        var lightsCount = Math.floor(remainingSpace / width);

        for (var i = 0; i < lightsCount; i++) {
            $(".lights-outer").append("<li class='" + newClass + "' style='left: " + (from + i * width) + "px'></li>");
        }
        if (window.innerWidth < 800) {
            for (var i = 0; i < lightsCount; i++) {
                $(".lights-outer").append("<li class='" + newClass + "' style='left: " + (from + i * width) + "px'></li>");
            }
        }
        var newLi = $("li." + newClass);

        if (newLi.length > 0) {
            var blankSpace = end - (newLi.last().offset().left - newLi.last().parent().offset().left + newLi.last().width());

            newLi.each(function () {
                $(this).css("margin-left", blankSpace / 2);
            })
        }
    }
});



